import { useState, Fragment } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useFetchData } from './_hooks/useFetchData';
import { CallsheetHeader } from './CallsheetHeader';
import { DailyProductionReport } from './DailyProductionReport';
import { Summary } from './Summary';

export function Callsheet () {
  const [loading, setLoading] = useState<boolean>(false);
  const [sceneMetadata, setSceneMetadata] = useState<any>({});
  const [currentShootingDay, setCurrentShootingDay] = useState<string>('1');

  useFetchData(setSceneMetadata, setLoading);
  
  const handleSetCurrentShootingDay = (day: string) => {
    setCurrentShootingDay(day);
  };
  console.log(sceneMetadata);
  return (
    <Container maxWidth="xl" sx={{ marginTop: 10 }}>
        {loading ? (
          <Box sx={{ display: 'flex', paddingTop: 1, paddingBottom: 2 }}><CircularProgress sx={{margin: '0 auto', marginTop: 1}} /></Box>
        ) : (
          <Fragment>
            <Box mx={2} mb={4}>
              <CallsheetHeader
                shootingDays={sceneMetadata?.shootingDays}
                setCurrentShootingDay={handleSetCurrentShootingDay}
                currentShootingDay={currentShootingDay}
                scenesPlanned={sceneMetadata?.scenes?.length}
                realShootingDays={sceneMetadata?.realShootingDays}
                completedScenes={sceneMetadata?.completedScenes}
                totalSceneCoverage={sceneMetadata?.totalSceneCoverage}
                totalOfCoveredLines={sceneMetadata?.totalOfCoveredLines}
                totalOfPlannedScriptLines={sceneMetadata?.totalOfPlannedScriptLines}
              />
            </Box>
            <Box my={2}>
              <DailyProductionReport
                callSheetRawData={sceneMetadata?.callsheetRawData}
                currentShootingDay={currentShootingDay}
                realStartAndEnd={sceneMetadata?.realStartAndEnd}
                realTakes={sceneMetadata?.realTakes}
                clapperCatalog={sceneMetadata?.clapperCatalog}
              />
            </Box>
            <Box my={2}>
              <Summary
                firstShotTime={sceneMetadata?.shootingHours?.[currentShootingDay]?.firstStartTime}
                lastShotTime={sceneMetadata?.shootingHours?.[currentShootingDay]?.lastStartTime}
                currentDay={currentShootingDay}
                totalPlannedScriptLines={sceneMetadata?.totalPlannedScriptLines}
                plannedScriptLines={sceneMetadata?.plannedScriptLinesPerScene}
                coveredScriptLines={sceneMetadata?.coveredScriptLinesPerScene}
                callSheetRawData={sceneMetadata?.callsheetRawData}
                actionDurationsPerScene={sceneMetadata?.actionDurationsPerScene}
              />
            </Box>
          </Fragment>
        )}
    </Container>
  )
}
